import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { DataProvider } from './context/DataContext';
import { SeasonProvider } from './context/SeasonContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DataProvider>
      <SeasonProvider>
        <App />
      </SeasonProvider>
    </DataProvider>
  </React.StrictMode>
);
